'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const compact = require('lodash.compact');
const findNameSpace = require('find-namespace-value');

const {STORE} = require('../constants/recommendationsConstants');
const {filterCollectionUniqueItems} = require('../utils/filterCollectionUniqueItems.es');

class RecommendationsStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this._collections = {};
    }

    getCollection(collectionKey) {
        return this._collections[collectionKey];
    }

    /**
     * Returns an array of filtered collections containing unique items.
     *
     * @param {array} collectionKeys - an array of Backbone collection keys.
     * @param {number} itemsPerPage - number of unique items to filter out.
     * @returns {array}
     */
    getCollectionsFiltered(collectionKeys, itemsPerPage) {
        const collections = collectionKeys.map(key => {
            const collection = this.getCollection(key);
            return collection && collection.toJSON();
        });
        const flatCollections = compact(Array.prototype.concat.apply([], collections));

        return filterCollectionUniqueItems(flatCollections, itemsPerPage);
    }

    getRecommendation(collectionKey, rank = 1) {
        const collection = this._collections[collectionKey];

        if (collection) {
            return collection.findWhere({rank}) || collection.first();
        }

        return undefined;
    }

    /**
     * Returns recommendations title and url
     */
    getRecommendations(collectionKey) {
        const collection = this._collections[collectionKey];

        if (collection) {
            return collection.map(recommendation => {
                return {
                    title: this._getTitle(recommendation),
                    url: recommendation.get('url')
                };
            });
        }

        return [];
    }

    getItems(collectionKey, rank = 1) {
        const recommendation = this.getRecommendation(collectionKey, rank);

        if (recommendation) {
            return recommendation.get('items').toJSON();
        }

        return [];
    }

    getUrl(collectionKey, rank = 1) {
        const recommendation = this.getRecommendation(collectionKey, rank);

        if (recommendation) {
            return recommendation.get('url');
        }

        return '';
    }

    getType(collectionKey, rank = 1) {
        const recommendation = this.getRecommendation(collectionKey, rank);

        if (recommendation) {
            return recommendation.get('recommendationType');
        }

        return '';
    }

    /**
     * Returns a recommendation title to be displayed on personalization carousels
     */
    getTitle(collectionKey, rank = 1) {
        const recommendation = this.getRecommendation(collectionKey, rank);

        return this._getTitle(recommendation);
    }

    _getTitle(recommendation) {
        const recommendable = recommendation && recommendation.get('recommendable');
        let result = '';

        if (recommendable) {
            const associatedCategory = recommendation.get('associatedCategory');
            const title = findNameSpace('properties.displayName', recommendable) || findNameSpace('name', recommendable);
            result = title;

            // If it's an attribute recommendation append L1 to the title
            if (associatedCategory) {
                const {name} = associatedCategory;
                result += ` ${name}`;
            }
        }

        return result;
    }

    _handleFetchSuccess(payload = {}) {
        const {collectionKey, collection} = payload;

        if (collectionKey) {
            this._collections[collectionKey] = collection;
            this.emitChange();
        }
    }
};

RecommendationsStore.storeName = 'RecommendationsStore';

RecommendationsStore.handlers = {
    [STORE.FETCH_SUCCESS]: '_handleFetchSuccess'
};

module.exports = RecommendationsStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/RecommendationsStore.es.js